import React, { FC } from 'react'
import { ContentfulRichText } from '@/atoms/ContentfulRichText'
import { FlexColumn } from '@/atoms/FlexContainers'
import { HeadingLG, TitleLG } from '@/atoms/Text'
import { Accordion, AccordionItem } from '@/molecules/Accordion'
import { GiveawayFaqTab } from '@/types/codegen-contentful'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { useTranslate } from '@/utils/translate/translate-client'
import { giveawayRichTextOverrides } from '../../utils/richtextUtils'

interface Props {
  content: GiveawayFaqTab
}

export const PresalesFAQsTab: FC<Props> = ({ content }) => {
  const { t } = useTranslate('tickets')
  const { asPath } = useSafeRouter()
  const hash = (asPath as string).split('#')[1] || ''
  const faqs = content.faqsCollection?.items || []

  return (
    <FlexColumn className="mx-auto mb-16 gap-4 px-4 pt-16 md:px-16 md:pb-32 lg:px-24">
      <HeadingLG className="font-semibold uppercase md:font-bold" color="giveaway-text-primary-dark">
        {t('GiveawayFaqs', 'Faqs')}
      </HeadingLG>
      <Accordion>
        {faqs.map((faq, index: number) => {
          if (!faq) return null
          return (
            <AccordionItem
              labelClassName="w-full text-blue font-semibold"
              showTopBorder
              label={
                <TitleLG weight="semibold" color="giveaway-text-primary-dark">
                  {faq.question}
                </TitleLG>
              }
              key={faq.sys.id}
              borderColor="core-gray-300"
              defaultOpen={index === 0 || Boolean(hash && faq.key === hash)}
            >
              <ContentfulRichText {...faq.answer} renderOptionOverrides={giveawayRichTextOverrides} />
            </AccordionItem>
          )
        })}
      </Accordion>
    </FlexColumn>
  )
}
